var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealtyfeedSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.042,
    height: 54.043,
    viewBox: "0 0 54.042 54.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "in40ttdg7a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 23349",
    transform: "translate(182 207)",
    style: {
      fill: "#f4f4f7"
    },
    d: "M0 0h31v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51195"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47695",
    transform: "translate(-5.983 -5.983)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5358",
    cx: 23.337,
    cy: 23.337,
    r: 23.337,
    transform: "translate(9.667 9.667)",
    style: {
      fill: "#151aae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45931",
    d: "M1029.661 1859.443a26 26 0 1 1-26 26 26.034 26.034 0 0 1 26-26m0-.667a26.671 26.671 0 1 0 26.671 26.671 26.7 26.7 0 0 0-26.671-26.671z",
    transform: "translate(-996.657 -1852.443)",
    style: {
      fill: "#2164a6",
      stroke: "#151aae",
      strokeWidth: ".7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1",
    transform: "translate(-170.983 -190.06)",
    style: {
      clipPath: "url(#in40ttdg7a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51193"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 78345",
    style: {
      fill: "#f4f4f7"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.81 26.254C7.367 26.254.5 20.478.5 13.377.5 6.277 7.368.5 15.81.5c8.441 0 15.309 5.777 15.309 12.877 0 7.1-6.868 12.877-15.31 12.877z",
    style: {
      stroke: "none"
    },
    transform: "translate(180.688 203.557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.81 1C7.642 1 1 6.552 1 13.377c0 6.825 6.643 12.377 14.81 12.377 8.165 0 14.809-5.552 14.809-12.377C30.619 6.552 23.975 1 15.809 1m0-1c8.732 0 15.81 5.99 15.81 13.377 0 7.388-7.078 13.377-15.81 13.377C7.08 26.754 0 20.765 0 13.377 0 5.99 7.078 0 15.81 0z",
    style: {
      fill: "#707070",
      stroke: "none"
    },
    transform: "translate(180.688 203.557)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.944 36.017a17.675 17.675 0 0 1-6.661-1.3 17.587 17.587 0 0 1-5.856-3.9l-.242-.243A17.708 17.708 0 0 1 .324 21.4 17.876 17.876 0 0 1 1.3 11.323a17.659 17.659 0 0 1 3.885-5.877l.242-.246A17.595 17.595 0 0 1 14.563.325a17.7 17.7 0 0 1 10.042.975 17.587 17.587 0 0 1 5.856 3.9L43.22 18 30.461 30.8a17.595 17.595 0 0 1-9.136 4.878 17.767 17.767 0 0 1-3.381.339zM9.663 16.969l2.292 3.517h6.226l3.649 6.307H28l-3.88-6.307h1.59a4.977 4.977 0 0 0 2-.749 4.526 4.526 0 0 0 1.99-4.082 4.926 4.926 0 0 0-2-4.206 5.236 5.236 0 0 0-1.986-.873H5.5l2.291 3.515h16.703a1.338 1.338 0 0 1 .453.318 1.519 1.519 0 0 1 .308.48 1.962 1.962 0 0 1 .133.766 1.769 1.769 0 0 1-.146.727 1.065 1.065 0 0 1-.307.394.924.924 0 0 1-.441.193z",
    transform: "translate(178.255 199.568)",
    style: {
      fill: "#151aae"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtyfeedSocial);
export default __webpack_public_path__ + "static/media/realtyfeed-social.8938749bf6e4beb5e0810a68bc390e7a.svg";
export { ForwardRef as ReactComponent };